/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import moment from 'moment';

const MaintainGroupPlanDateRenderComponent = (props) => {
  const { value } = props;
  return (
    <div style={{ height: 'max-content' }}>
      <span>{value ? moment(value).format('MM/DD/YYYY') : ''}</span>
    </div>
  );
};

export default MaintainGroupPlanDateRenderComponent;
